import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RouterModule, Routes } from "@angular/router";
import { PartialsModule } from "../../partials/partials.module";
import { TranslateModule } from "@ngx-translate/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { HttpClientModule } from "@angular/common/http";

// Material
import {
	MatAutocompleteModule,
	MatInputModule,
	MatPaginatorModule,
	MatProgressSpinnerModule,
	MatSortModule,
	MatTableModule,
	MatSelectModule,
	MatMenuModule,
	MatBottomSheetModule,
	MatButtonModule,
	MatCheckboxModule,
	MatDialogModule,
	MatTabsModule,
	MatNativeDateModule,
	MatIconModule,
	MatDatepickerModule,
	MatExpansionModule,
	MatSnackBarModule,
	MatTooltipModule,
	MatToolbarModule,
	MatFormFieldModule,
} from "@angular/material";
import { ExamenComponent } from "./examen/examen.component";
import { AddexamenComponent } from "./examen/addexamen/addexamen.component";
import { ViewexamenComponent } from "./examen/viewexamen/viewexamen.component";
import { MatTableExporterModule } from "mat-table-exporter";
import { ShowimagesComponent } from './examen/showimages/showimages.component';
import { DynamicCrudComponent } from "./dynamic-crud/dynamic-crud.component";
import { DynamicCrudDialogComponent } from "./dynamic-crud/dynamic-crud-dialog/dynamic-crud-dialog.component";
import { OrdenanceComponent } from "./ordenance/ordenance.component";
import { PartageOrdonnanceSheetComponent } from "./ordenance/partage-ordonnance-sheet/partage-ordonnance-sheet.component";
import { StaticListComponent } from "./static-list/static-list.component";
import { AvertArabeDirective } from "../../../core/apps/avert-arabe.directive";

const staticListRoutes: Routes = [
	{ path: "frequences", component: StaticListComponent, data: { staticList: { title: "Fréquence", key: "frequences" } } },
	{ path: "severite", component: StaticListComponent, data: { staticList: { title: "Sévérité", key: "severite" } } },
	{ path: "prevalence", component: StaticListComponent, data: { staticList: { title: "Prévalence", key: "prevalences" } } },
	{ path: "forme", component: StaticListComponent, data: { staticList: { title: "Forme", key: "formes" } } },
];

const dynamicCrudRoutes: Routes = [
	{ path: "conduite", component: DynamicCrudComponent, data: { dynamicCrud: { title: "Conduite à tenir", collection: "Conduites" } } },
	{ path: "diagnostic", component: DynamicCrudComponent, data: { dynamicCrud: { title: "Diagnostic", collection: "diagnostics" } } },
	{ path: "entreprise", component: DynamicCrudComponent, data: { dynamicCrud: { title: "Entreprises", collection: "Entreprises" } } },
	{ path: "ecloseries", component: DynamicCrudComponent, data: { dynamicCrud: { title: "Ecloseries", collection: "Ecloseries" } } },
	{ path: "especes", component: DynamicCrudComponent, data: { dynamicCrud: { title: "Espèces", collection: "Especes" } } },
	{ path: "incident", component: DynamicCrudComponent, data: { dynamicCrud: { title: "Incidents", collection: "Incidents" } } },
	{ path: "parasitaire", component: DynamicCrudComponent, data: { dynamicCrud: { title: "Parasitaire", collection: "Parasitaire" } } },
	{ path: "bacteriologique", component: DynamicCrudComponent, data: { dynamicCrud: { title: "Bactériologique", collection: "Bacteriologique" } } },
	{ path: "embonpoint", component: DynamicCrudComponent, data: { dynamicCrud: { title: "Etat d'embonpoint", collection: "Embonpoints" } } },
	{ path: "revetementcutane", component: DynamicCrudComponent, data: { dynamicCrud: { title: "Revêtement cutané", collection: "Revetementcutane" } } },
	{ path: "nageoires", component: DynamicCrudComponent, data: { dynamicCrud: { title: "Nageoires", collection: "Nageoires" } } },
	{ path: "opercule", component: DynamicCrudComponent, data: { dynamicCrud: { title: "Opercule", collection: "Opercule" } } },
	{ path: "bouche", component: DynamicCrudComponent, data: { dynamicCrud: { title: "Bouche", collection: "Bouche" } } },
	{ path: "estomac", component: DynamicCrudComponent, data: { dynamicCrud: { title: "Estomac", collection: "Estomac" } } },
	{ path: "intestin", component: DynamicCrudComponent, data: { dynamicCrud: { title: "Intestin", collection: "Intestin" } } },
	{ path: "branchie", component: DynamicCrudComponent, data: { dynamicCrud: { title: "Branchie", collection: "Branchie" } } },
	{ path: "coeur", component: DynamicCrudComponent, data: { dynamicCrud: { title: "Coeur", collection: "Coeur" } } },
	{ path: "tete", component: DynamicCrudComponent, data: { dynamicCrud: { title: "Tête", collection: "Tete" } } },
	{ path: "yeux", component: DynamicCrudComponent, data: { dynamicCrud: { title: "Yeux", collection: "Yeux" } } },
	{ path: "cerveau", component: DynamicCrudComponent, data: { dynamicCrud: { title: "Cerveau", collection: "Cerveau" } } },
	{ path: "rate", component: DynamicCrudComponent, data: { dynamicCrud: { title: "Rate", collection: "Rate" } } },
	{ path: "foie", component: DynamicCrudComponent, data: { dynamicCrud: { title: "Foie", collection: "Foie" } } },
	{ path: "vesiculebiliaire", component: DynamicCrudComponent, data: { dynamicCrud: { title: "Vésicule biliaire", collection: "Vesiculebiliaire" } } },
	{ path: "rein", component: DynamicCrudComponent, data: { dynamicCrud: { title: "Rein", collection: "Rein" } } },
	{ path: "vessienatatoire", component: DynamicCrudComponent, data: { dynamicCrud: { title: "Vessie natatoire", collection: "Vessienatatoire" } } },
	{ path: "autres", component: DynamicCrudComponent, data: { dynamicCrud: { title: "Autres", collection: "autres" } } },
	{ path: "autreexameninterne", component: DynamicCrudComponent, data: { dynamicCrud: { title: "Autres", collection: "autres" } } },
	{ path: "molecules", component: DynamicCrudComponent, data: { dynamicCrud: { title: "Molécules", collection: "Molecules" } } },
	{ path: "dureetraitement", component: DynamicCrudComponent, data: { dynamicCrud: { title: "Durée du traitement", collection: "Dureetraitements" } } },
];

const routes: Routes = [
	{ path: "examen", component: ExamenComponent },
	{ path: "ordenance", component: OrdenanceComponent },
	...staticListRoutes,
	...dynamicCrudRoutes,
];
@NgModule({
	declarations: [
		ExamenComponent,
		AddexamenComponent,
		ViewexamenComponent,
		ShowimagesComponent,
		DynamicCrudComponent,
		DynamicCrudDialogComponent,
		OrdenanceComponent,
		PartageOrdonnanceSheetComponent,
		StaticListComponent,
		AvertArabeDirective,
	],
	imports: [
		MatTableExporterModule,
		CommonModule,
		HttpClientModule,
		PartialsModule,
		FormsModule,
		ReactiveFormsModule,
		TranslateModule.forChild(),
		MatBottomSheetModule,
		MatButtonModule,
		MatMenuModule,
		MatSelectModule,
		MatInputModule,
		MatTableModule,
		MatAutocompleteModule,
		MatIconModule,
		MatNativeDateModule,
		MatDatepickerModule,
		MatPaginatorModule,
		MatSortModule,
		MatCheckboxModule,
		MatProgressSpinnerModule,
		MatSnackBarModule,
		MatExpansionModule,
		MatTabsModule,
		MatTooltipModule,
		MatDialogModule,
		MatToolbarModule,
		MatFormFieldModule,
		RouterModule.forChild(routes),

	],
	entryComponents: [
		DynamicCrudDialogComponent,
		PartageOrdonnanceSheetComponent,
	],
	providers: [],
})
export class AppsModule {}
